import { ReactNode } from 'react';

import { Config } from './config';

let isLoaded = false;

/**
 * This component was created to solve the following issues:
 * 1. If we put `await import(...)` at top level (say at main.tsx), we are getting recursion in dynamic imports.
 *    I didnt manage to figure out this issue completely, but dynamic imports break in production mode, because
 *    when `devServer` script is loaded, it then gets stuck on importing parent file, that loaded `devServer` itself.
 * 2. Now, if we dont "await" it (to eliminate recursion or whatever the previous issue is), problem occurs that
 *    some http requests are executed before `devServer` is loaded, so we cannot use mock endpoints for them.
 *
 * Here, we rely on suspense behavior to wait until script is loaded and initialized properly,
 * and only then we load the entire application which works fine both in dev/prod mode.
 */
export function WithDevMockServer({ children }: { children: ReactNode }) {
  if (Config.useMockServer) {
    if (!isLoaded) {
      throw import('./tests/mockApi/devServer').then(() => {
        isLoaded = true;
      });
    }
  }

  return children;
}
